function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useCallback, useEffect, useLayoutEffect } from "react";
import { useIntl } from "react-intl";
import { array, func, shape, string } from "prop-types";
import { useToasts, useWindowSize } from "@magento/peregrine";
import { useApp } from "@magento/peregrine/lib/talons/App/useApp";
import globalCSS from "../../index.css";
import { HeadProvider, StoreTitle } from "../Head";
import Main from "../Main";
import Mask from "../Mask";
import Routes from "../Routes";
import ToastContainer from "../ToastContainer";
import Icon from "../Icon";
import { AlertCircle as AlertCircleIcon, CheckCircle as CheckCircleIcon, CloudOff as CloudOffIcon, Wifi as WifiIcon } from "react-feather";
import useFreeShipping from "@magento/peregrine/lib/talons/Header/useFreeShipping";
import injectDocumentScript from "../../util/injectDocumentScript";
import { useStoreSwitcher } from "@magento/peregrine/lib/talons/Header/useStoreSwitcher";
import isPrerenderUserAgent from "../../util/isPrerenderUserAgent";
import { GrowthBook, GrowthBookProvider } from "@growthbook/growthbook-react";
import { sendGTMEvent } from "../../util/initGTM";
import { useUserContext } from "@magento/peregrine/lib/context/user";
import md5 from 'md5';
import HreflangTags from "../HreflangTags";
import { Helmet } from 'react-helmet-async';
import BrowserPersistence from "@magento/peregrine/lib/util/simplePersistence";
import CookieConsent from "../CookieConsent";
import { sendCustomer, sendError } from "../../util/noibu_helpers";
var storage = new BrowserPersistence();
export var OnlineIcon = /*#__PURE__*/React.createElement(Icon, {
  src: WifiIcon,
  attrs: {
    width: 18
  }
});
export var OfflineIcon = /*#__PURE__*/React.createElement(Icon, {
  src: CloudOffIcon,
  attrs: {
    width: 18
  }
});
export var ErrorIcon = /*#__PURE__*/React.createElement(Icon, {
  src: AlertCircleIcon,
  attrs: {
    width: 18
  }
});
export var SuccessIcon = /*#__PURE__*/React.createElement(Icon, {
  src: CheckCircleIcon,
  attrs: {
    width: 18
  }
});
export var getBuildVersion = function () {
  var version = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
  var [_, build_num] = version && version.split('-');
  if (build_num) {
    return parseInt(build_num);
  }
  return 0;
};

// Create a GrowthBook instance
// Note: use GROWTh_BOOK.ready flag with loading indicator
// and timeout indicator if need to block web-loading
// until experiment gets loaded
// And use GROWTH_BOOK.isOn() for it,
// because Provider hooks are not accessible initially
export var GROWTH_BOOK = new GrowthBook({
  apiHost: process.env.GB_API_HOST,
  clientKey: process.env.GB_CLIENT_KEY,
  enableDevMode: process.env.GB_DEV,
  trackingCallback: (experiment, result) => {
    console.log("Experiment Viewed", {
      experimentId: experiment.key,
      variationId: result.key
    });
    console.log(experiment, result);
    sendGTMEvent({
      event: "experiment_viewed",
      event_category: "experiment",
      experiment_id: experiment.key,
      variation_id: result.key
    });
  }
  //TODO: test if clientId is required from the initialization
  //clientId: getVisitorId()
});

var get_gtm_device_id_interval;
var App = props => {
  var {
    markErrorHandled,
    renderError,
    unhandledErrors
  } = props;
  var {
    formatMessage
  } = useIntl();
  var [, {
    addToast
  }] = useToasts();
  var {
    currentStoreCode
  } = useStoreSwitcher();
  var [{
    currentUser,
    userData,
    isSignedIn
  }] = useUserContext();
  var signedUser = currentUser !== null && currentUser !== void 0 && currentUser.email ? currentUser : userData !== null && userData !== void 0 && userData.email ? userData : null;

  //to fill localStorage with needed value
  useFreeShipping();
  var isPrerender = isPrerenderUserAgent();
  var isMobile = useWindowSize().innerWidth <= 1248;
  var landingPageUrl = document.location.protocol + "//" + document.location.hostname + document.location.pathname + document.location.search;
  var ERROR_MESSAGE = formatMessage({
    id: "app.errorUnexpected",
    defaultMessage: "Sorry! An unexpected error occurred."
  });
  var prefixHelpCode = currentStoreCode === 'fr' ? 'Code d\'aide: ' : 'Help code: ';
  useEffect(() => {
    if (renderError) {
      sendError(renderError, ["RenderError", "render"]);
    }
    if (unhandledErrors && unhandledErrors.length) {
      sendError(JSON.stringify(unhandledErrors), ["UnhandedErrors", "render"]);
    }
  }, [renderError, unhandledErrors]);

  //Clearing Cache from localstorage
  useEffect(() => {
    if (!localStorage.version_app || getBuildVersion(localStorage.version_app) < getBuildVersion(process.env.CACHE_VERSION)) {
      localStorage.clear();
      if (caches) {
        caches.keys().then(function (names) {
          for (var name of names) {
            caches.delete(name);
          }
        });
      }
      localStorage.setItem("version_app", process.env.CACHE_VERSION);
    }
  }, []);

  // initial landing calls
  useEffect(() => {
    // Load features from the GrowthBook API
    GROWTH_BOOK.loadFeatures({
      autoRefresh: true
    });

    // Setting initial landing url for GTM
    storage.setItem("landing_initial_page_url", landingPageUrl);
  }, []);
  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
  }, []);

  //Woobox
  useEffect(() => {
    window.woobox = (d, s, id) => {
      var js,
        fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "https://woobox.com/js/plugins/woo.js";
      js.type = "text/javascript";
      fjs.parentNode.insertBefore(js, fjs);
    };
  }, []);

  //Rakuten init
  useEffect(() => {
    (function (url) {
      if (process.env.PIXEL_ENABLED == "true") {
        /*Tracking Bootstrap Set Up DataLayer objects/properties here*/
        window.rakutenDataLayer = false; // Set custom DataLayer name if 'DataLayer' conflicts
        var dln = window.rakutenDataLayer || "DataLayer";
        if (!window[dln]) {
          window[dln] = {};
        }
        if (!window[dln].events) {
          window[dln].events = {};
        }
        window[dln].events.SPIVersion = window[dln].events.SPIVersion || "3.4.1";
        var loc,
          ct = document.createElement("script");
        ct.type = "text/javascript";
        ct.async = true;
        ct.src = url;
        loc = document.getElementsByTagName("script")[0];
        loc.parentNode.insertBefore(ct, loc);
      }
    })(document.location.protocol + "//tag.rmp.rakuten.com/124683.ct.js");
  }, []);

  //on user signed in
  useEffect(() => {
    var email = signedUser === null || signedUser === void 0 ? void 0 : signedUser.email;
    var hashed_email_id = email && md5(email);
    var growthAttributes = GROWTH_BOOK.getAttributes();
    console.log(growthAttributes);
    var getCompanyName = () => {
      if (email !== null && email !== void 0 && email.includes("@badger.blue")) {
        return "Blue Badger";
      }
      if (email !== null && email !== void 0 && email.includes("@stokesstores.com")) {
        return "Stokes";
      }
      return null;
    };
    GROWTH_BOOK.setAttributes(_objectSpread(_objectSpread({}, growthAttributes), {}, {
      id: hashed_email_id,
      country: "CA",
      mobile: isMobile,
      //browser: "chrome",
      url: landingPageUrl,
      loggedIn: isSignedIn,
      company: getCompanyName(),
      isSubscribed: signedUser === null || signedUser === void 0 ? void 0 : signedUser.is_subscribed
    }));
    if (signedUser && email) {
      sendCustomer({
        customerID: hashed_email_id,
        campaign: getCompanyName(),
        isLoggedIn: 'True',
        variant: growthAttributes === null || growthAttributes === void 0 ? void 0 : growthAttributes.experimentId
      });
    } else {
      sendCustomer({
        isLoggedIn: 'False',
        variant: growthAttributes === null || growthAttributes === void 0 ? void 0 : growthAttributes.experimentId
      });
    }
  }, [signedUser]);

  //setting clientId for the BrowthBook
  useEffect(() => {
    //avoid having infinite rerender
    var times = 0;

    //need to wait for GTM to be initialized
    get_gtm_device_id_interval = setInterval(() => {
      try {
        var _ga_cookie$;
        var ga_cookie = document.cookie.match(/_ga=(.+?);/);
        var gtm_client_id = ga_cookie && ga_cookie.length > 1 && ((_ga_cookie$ = ga_cookie[1]) === null || _ga_cookie$ === void 0 || (_ga_cookie$ = _ga_cookie$.split('.')) === null || _ga_cookie$ === void 0 || (_ga_cookie$ = _ga_cookie$.slice(-2)) === null || _ga_cookie$ === void 0 ? void 0 : _ga_cookie$.join("."));
        if (gtm_client_id !== null && gtm_client_id !== void 0 && gtm_client_id.length) {
          GROWTH_BOOK.setAttributes(_objectSpread(_objectSpread({}, GROWTH_BOOK.getAttributes()), {}, {
            clientId: gtm_client_id
          }));
          window.clearInterval(get_gtm_device_id_interval);
        }
      } catch (e) {
        console.error(e);
      }
      if (times > 600) {
        window.clearInterval(get_gtm_device_id_interval);
      }
      times++;
    }, 1000);
  }, []);
  useEffect(() => {
    if (process.env.NOIBU_ENABLED === 'true' && process.env.NOIBU_DOMAIN_ID) {
      setTimeout(() => {
        var script = document.createElement('script');
        script.innerHTML = 'window.addEventListener("noibuSDKReady", () => {' + 'let button = document.getElementById("request-help-code");' + 'let label = document.getElementById("help-code-result");' + 'button.addEventListener("click", async () => {' + 'let helpCode = await window.NOIBUJS.requestHelpCode(false);' + 'let _helpCode = "' + prefixHelpCode + '" + helpCode;' + 'label.innerText = _helpCode;' + 'button.classList.add("_hidden");' + '});' + '});';
        script.async = true;
        document.head.appendChild(script);
      }, 200);
    }
  }, []);
  useLayoutEffect(() => {
    if (!isPrerender) {
      injectDocumentScript({
        src: "https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=".concat(process.env.KLAVIYO_SITE_ID),
        async: true,
        type: "text/javascript"
      }).then(() => {
        console.warn("Klaviyo injected");
      });
      injectDocumentScript({
        src: process.env.HEYDAY_SNIPPET + currentStoreCode + "/setupchat.js",
        async: true,
        type: "text/javascript"
      });
    } else {
      console.warn("Klaviyo not injected due to prerender");
    }
  }, [isPrerender]);
  var handleIsOffline = useCallback(() => {
    addToast({
      type: "error",
      icon: OfflineIcon,
      message: formatMessage({
        id: "app.errorOffline",
        defaultMessage: "You are offline. Some features may be unavailable."
      }),
      timeout: 3000
    });
  }, [addToast, formatMessage]);
  var handleIsOnline = useCallback(() => {
    addToast({
      type: "info",
      icon: OnlineIcon,
      message: formatMessage({
        id: "app.infoOnline",
        defaultMessage: "You are online."
      }),
      timeout: 3000
    });
  }, [addToast, formatMessage]);
  var handleError = useCallback((error, id, loc, handleDismissError) => {
    var errorToastProps = {
      icon: ErrorIcon,
      message: "".concat(ERROR_MESSAGE, "\nDebug: ").concat(id, " ").concat(loc),
      onDismiss: remove => {
        handleDismissError();
        remove();
      },
      timeout: 15000,
      type: "error"
    };
    addToast(errorToastProps);
  }, [ERROR_MESSAGE, addToast]);
  var talonProps = useApp({
    handleError,
    handleIsOffline,
    handleIsOnline,
    markErrorHandled,
    renderError,
    unhandledErrors
  });
  var {
    hasOverlay
  } = talonProps;
  if (renderError) {
    return /*#__PURE__*/React.createElement(HeadProvider, null, /*#__PURE__*/React.createElement(Helmet, null, /*#__PURE__*/React.createElement("meta", {
      name: "prerender-status-code",
      content: "404"
    })), /*#__PURE__*/React.createElement(GrowthBookProvider, {
      growthbook: GROWTH_BOOK
    }, /*#__PURE__*/React.createElement(StoreTitle, null), /*#__PURE__*/React.createElement(Main, {
      isMasked: true
    }), /*#__PURE__*/React.createElement(Mask, {
      isActive: true
    }), /*#__PURE__*/React.createElement(ToastContainer, null)));
  }
  return /*#__PURE__*/React.createElement(HeadProvider, null, /*#__PURE__*/React.createElement(GrowthBookProvider, {
    growthbook: GROWTH_BOOK
  }, /*#__PURE__*/React.createElement(StoreTitle, null), /*#__PURE__*/React.createElement(HreflangTags, null), /*#__PURE__*/React.createElement(Main, {
    isMasked: hasOverlay,
    isPrerender: isPrerender
  }, /*#__PURE__*/React.createElement(Routes, null)), /*#__PURE__*/React.createElement(CookieConsent, null), /*#__PURE__*/React.createElement(ToastContainer, null)));
};
App.propTypes = {
  markErrorHandled: func.isRequired,
  renderError: shape({
    stack: string
  }),
  unhandledErrors: array
};
App.globalCSS = globalCSS;
export default App;